// DO NOT EDIT -- generated from fs/cook/cook_options.proto

import * as bundlestore from '../bundlestore';
import * as protobuf from '../../google/protobuf';
import * as schema from '../shared/schema';

export enum CookMode {
  COOK_MODE_INVALID = 0,
  /** Whether the cook should be a batch processing job where all raw events are cooked at once */
  COOK_MODE_BATCH = 1,
  /** Whether the cook should be an incremental processing job where only the most recent bundles are cooked */
  COOK_MODE_INCREMENTAL = 2
}

export enum CookRequester {
  COOK_REQUESTER_INVALID = 0,
  /** The caller of the cook is a scheduled cook from julia */
  COOK_REQUESTER_SCHEDULED = 1,
  /** The caller of the cook is an on demand cook from julia-on-demand */
  COOK_REQUESTER_ON_DEMAND = 2,
  /** The recook queue is requesting that the cook be redone (e.g. redactions, bug fixes, etc) */
  COOK_REQUESTER_RECOOK = 3,
  /** Microwave or local cooker is requesting a cook. */
  COOK_REQUESTER_LOCAL = 4
}

export enum CookStatus {
  COOK_STATUS_INVALID = 0,
  /** This is the very first cook ever for the page */
  COOK_STATUS_FIRST_COOK = 1,
  /** This is a followup cook where we are regularly processing new bundles as they come in. */
  COOK_STATUS_STANDARD_COOK = 2,
  /** Some error has occurred which requires the cook to start from scratch */
  COOK_STATUS_FALLBACK_COOK = 3
}

export enum FinalCookStatus {
  FINAL_COOK_STATUS_INVALID = 0,
  /** We have received the final cook signal and are cooking the page for the final time for the first time. */
  FINAL_COOK_STATUS_FIRST_FINAL_COOK = 1,
  /** In rare cases, we receive more data after a final cook and have to cook a subsequent time. */
  FINAL_COOK_STATUS_FOLLOWUP_FINAL_COOK = 2
}

/** CookOptions is leveraged by any cook requester to configure how the cook should run */
export interface CookOptions {
  /** The Cooking Mode indicates how the cook should operate (e.g. batch versus streaming) */
  cookingMode: CookMode;
  /**
   * The caller of the cook requesting the processing. Sometimes, the cook may want to function differently based on
   * the caller (e.g. turning off side effects)
   */
  cookRequester: CookRequester;
  /** For logging and metric purposes only, the exact name of the requester of the cook. */
  requesterName: string;
  /** The cook status informs what stage the cook is at in processing the page (e.g. first cook ever or recook). */
  cookStatus: CookStatus;
  /** The final cook status informs us whether we have finalized the page for cook (e.g. first final cook or subsequent) */
  finalCookStatus: FinalCookStatus;
  /** If true, we will do a full cook from scratch even if there are no new raw events. */
  forceFullCook: boolean;
  /** Whether we should include all data attributes for cook processing */
  includeAllDataAttributes: boolean;
  /** Whether to skip Cloracle page clustering */
  skipPageClustering: boolean;
  /** How many failures we have experienced in trying to cook this page. */
  numberFailures: number;
  /** The timestamp of the last raw event processed for this page in the previous cook */
  lastEventTime: protobuf.timestamp | null;
  /** The next bundle sequence to cook. */
  nextBundleSequence: protobuf.int64;
  /** Any labels to be used while recording metrics. */
  labels: { [key: string]: string };
  /**
   * Whether this cook should run in comparison mode to produce the products with saving only the minimal needed to
   * run future comparisons (e.g. CookState).
   * Side effects like webhooks, persisting  cook products, emitting events, webhooks, etc
   */
  comparisonCook: boolean;
  /** Whether this is an initial run of the cook to pre-populate the CookedProducts for a main incremental comparison run */
  comparisonStarter: boolean;
  /** Whether this is a batch cook that is running in tandem with a comparison */
  comparisonBatch: boolean;
  /** Whether the final cook for a page has completed */
  finalCookCompleted: boolean;
}

/** CompletePageArgs is a wrapper that contains both the 64 (server) and 128 (client) bit versions of the args */
export interface CompletePageArgs {
  pageArgs64: schema.PageArgsProto | null;
  pageArgs128: bundlestore.PageArgs128Proto | null;
}
